<div class="bk-page legacy">
<header class="bk-page__head legacy__head">
  <div class="bk-page__intro">
    <p class="bk-eyebrow">SMS</p>
    <h1 class="bk-page__title">{{ isEdit ? "Edit draft" : "New message" }}</h1>
    <p class="bk-page__sub">Change the recipients, message or schedule, then preview it to send, or cancel to save it as a draft.</p>
  </div>
</header>

<add-contact-modal
  [selectedContacts]="selected_contacts"
  [add_recipient]="add_recipient"
  (selectedContactsChange)="handleSelectedContactsChange($event)"
  (close)="closeModal()"
></add-contact-modal>

<legacy-add-tags-modal
  [selectedTags]="selected_tags"
  [add_recipient]="add_tags"
  (selectedTagsChange)="handleSelectedTagsChange($event)"
  (close)="closeTag()"
></legacy-add-tags-modal>

<add-organisation-modal
  [selectedOrg]="selected_organisation"
  [add_recipient]="add_organization"
  (selectedOrgsChange)="handleSelectedOrgsChange($event)"
  (close)="closeOrganization()"
></add-organisation-modal>

<legacy-add-segments-modal
  [selectedSegments]="selected_segments"
  [add_recipient]="add_segment"
  (selectedSegmentsChange)="handleSelectedSegmentsChange($event)"
  (close)="closeSegment()"
></legacy-add-segments-modal>

<add-recipient [open]="isDraft">
  <div class="createContactForm">
    <div class="legacy__draft">
      <nav
        style="border-top-left-radius: 20px; border-top-right-radius: 20px"
        class="headerdark:bg-transparent theme-border border-b px-5 py-4 flex items-center justify-between"
      >
        <p class="!mb-0 text-lg font-semibold">Save as draft?</p>

        <!-- close -->
        <div class="closeIcon cursor-pointer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            (click)="closeDraft()"
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
          >
            <path
              fill="currentColor"
              d="M2.93 17.07A10 10 0 1 1 17.07 2.93A10 10 0 0 1 2.93 17.07m1.41-1.41A8 8 0 1 0 15.66 4.34A8 8 0 0 0 4.34 15.66m9.9-8.49L11.41 10l2.83 2.83l-1.41 1.41L10 11.41l-2.83 2.83l-1.41-1.41L8.59 10L5.76 7.17l1.41-1.41L10 8.59l2.83-2.83z"
            />
          </svg>
        </div>
      </nav>
      <div class="flex-1 p-3 mt-5">
        <img src="drafticon.svg" alt="" />
      </div>
      <div class="flex-1 mt-7 content-center flex flex-row justify-between p-4">
        <button (click)="discard()" class="bk-btn bk-btn--ghost legacy__draft-btn">
          Discard
        </button>

        <button (click)="saveDraft()" class="bk-btn bk-btn--primary legacy__draft-btn">
          @if(loading){
          <svg
            class="animate-spin -ml-1 mr-3 h-5 w-5"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          } Save
        </button>
      </div>
    </div>
  </div>
</add-recipient>

<form [formGroup]="myForm" (ngSubmit)="onSubmit()">
  <div style="display: flex; flex-direction: column; min-height: 84vh">
    <div class="flex flex-col flex-1 relative">
      <div class="create-msg">
        <div style="width: 55%">
          @if(formError){
          <p class="bk-field__error legacy__problem" role="alert">
            <span class="bk-sym" aria-hidden="true">error</span>Complete every field to continue.
          </p>
          }
          <div
            class="card bg-white dark:bg-black rounded-xl"
            [class.is-problem]="formError"
            [ngStyle]="{
              'height.px': recipient_view ? 350 : 200
            }"
          >
            <div (click)="recipientView()" class="p-5 info-card cursor-pointer">
              <p>Select recipient</p>
              <img
                style="cursor: pointer"
                [src]="!recipient_view ? 'dropicon.svg' : 'dropup.svg'"
                alt="Dropdown icon"
              />
            </div>
            <div class="border header-line"></div>

            @if(!recipient_view){
            <p
              class="p-5"
              style="font-size: 14px; color: #6c757d; font-weight: 400"
            >
              Choose your recipients to ensure your message reaches the right
              audience. Select from individuals, tags, organisations, and
              segments to send your message with precision.
            </p>
            } @if(recipient_view){
            <div class="px-4 flex w-full mb-[39px]">
              <div class="inputs w-full mt-6 grid gap-8">
                <div class="contactInputs flex gap-4 border-b">
                  <!-- phone numbers -->
                  <div class="phoneNumbers flex items-center gap-4 mb-6">
                    <input-field
                      label="Phone number"
                      labelClass=""
                      [errorMessage]="phoneNumberError"
                    >
                      <!-- <input class="input-style" type="number" formControlName="primaryContactNumber" /> -->
                      <ngx-mat-input-tel
                        formControlName="phoneNumber"
                        [enablePlaceholder]="true"
                        [preferredCountries]="['bw', 'za']"
                        [enableSearch]="true"
                      />
                    </input-field>

                    <customizable-button
                      title="Add Phone number"
                      (click)="addPhoneNumber()"
                    />
                  </div>
                </div>

                <div class="flex gap-4">
                  <input-field
                    errorMessage="{{ contact_error }}"
                    class="w-full"
                    label="Select contact"
                    labelClass=""
                  >
                    <option
                      (click)="openModal()"
                      style="cursor: pointer"
                      value=""
                    >
                      {{ selected_contacts.length }} contact selected
                    </option>
                  </input-field>
                  <input-field
                    errorMessage="{{ tags_error }}"
                    (click)="openTags()"
                    class="w-full"
                    label="Select tag"
                    labelClass=""
                  >
                    <option style="cursor: pointer" value="Toyota">
                      {{ selected_tags.length }} tags selected
                    </option>
                  </input-field>
                </div>
                <div class="flex gap-4">
                  <input-field
                    errorMessage="{{ organization_error }}"
                    (click)="openOrganization()"
                    class="w-full"
                    label="Select organisation"
                    labelClass=""
                  >
                    <option style="cursor: pointer" value="">
                      {{ selected_organisation.length }} organisation selected
                    </option>
                  </input-field>
                  <input-field
                    errorMessage="{{ segment_error }}"
                    (click)="openSegment()"
                    class="w-full"
                    label="Select segment"
                    labelClass=""
                  >
                    <option style="cursor: pointer" value="">
                      {{ selected_segments.length }} segment selected
                    </option>
                  </input-field>
                </div>
              </div>
            </div>
            }
          </div>

          <div
            style="width: 100%"
            class="card bg-white dark:bg-black mt-[25px] rounded-xl"
          >
            <div (click)="contentView()" class="p-5 info-card cursor-pointer">
              <p>Message content</p>
              <img
                [src]="content_view ? 'dropicon.svg' : 'dropup.svg'"
                alt="Dropdown icon"
              />
            </div>
            <div class="border header-line"></div>

            @if(!content_view){
            <p
              class="p-5"
              style="font-size: 14px; color: #6c757d; font-weight: 400"
            >
              Craft your message from scratch or select from our ready-to-use
              templates to get started quickly.
            </p>
            } @if(content_view){
            <div [formGroup]="getTemplate" class="px-4 flex flex-col w-full">
              <div class="inputs w-full mt-6 grid gap-8">
                <input-field
                  errorMessage="{{ subject_error }}"
                  required="true"
                  class="message-input"
                  label="Message subject"
                >
                  <input
                    required="true"
                    [formControl]="subjectControl"
                    placeholder="Message subject"
                    [(ngModel)]="messageSubject"
                    (ngModelChange)="onSubjectChange($event)"
                    class="input-style"
                  />
                </input-field>
                <input-field
                  errorMessage="{{ template_error }}"
                  class="w-full"
                  label="Select template"
                  labelClass=""
                >
                  <select
                    formControlName="template"
                    [(ngModel)]="templateValue"
                    (ngModelChange)="onMessageChange($event)"
                    class="input-style !bg-transparent"
                  >
                    <option value="" disabled>Select a template</option>
                    <option
                      *ngFor="let row of template_list"
                      value="{{ row.id }}"
                    >
                      {{ row.name }}
                    </option>
                  </select>
                </input-field>
                <input-field
                  errorMessage="{{ body_error }}"
                  class="message-body"
                  label="Message body"
                >
                  <!-- <textarea [formControl]="textareaControl" [(ngModel)]="messageValue"
                    (ngModelChange)="onTextareaChange($event)" class="input-style"></textarea> -->
                  <div class="">
                    <!-- <input-field label="Message body"> -->
                    <div class="flex items-start">
                      <div class="w-full">
                        <textarea
                          name="body"
                          id="body"
                          rows="5"
                          class="input-style !text-sm"
                          placeholder="Enter message here"
                          [formControl]="textareaControl"
                          #txtMessage
                          [(ngModel)]="messageValue"
                          (ngModelChange)="onTextareaChange($event)"
                        ></textarea>
                      </div>
                      <div class="shrink-0">
                        <app-dropdown right="0" className="bottom-0">
                          <div
                            ngProjectAs="clickable-item"
                            class="cursor-pointer bg-lightGrey dark:bg-darkGrey px-1 py-1 rounded relative"
                          >
                            <span> {{"{{}}"}} </span>
                          </div>
                          <div
                            ngProjectAs="dropdown-item"
                            class="filterContent min-w-[220px] dark:bg-primary/80 bg-white/80"
                          >
                            <div
                              class="w-full px-4 py-2 border-b theme-border font-bold flex items-center gap-2"
                            >
                              <mat-icon class="!text-2xl max-w-fit"
                                >person</mat-icon
                              >
                              <span>Contact attribute</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('firstName')"
                            >
                              <span>First name</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('lastName')"
                            >
                              <span>Last name</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('fullName')"
                            >
                              <span>Full name</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('emailAddress')"
                            >
                              <span>Email</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('primaryContactNumber')"
                            >
                              <span>Phone number</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('gender')"
                            >
                              <span>Gender</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('birthDate')"
                            >
                              <span>Birth date</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('country')"
                            >
                              <span>Country</span>
                            </div>
                            <div
                              class="w-full px-4 py-2 cursor-pointer theme-hover"
                              (click)="appendAttribute('city')"
                            >
                              <span>City</span>
                            </div>
                          </div>
                        </app-dropdown>
                      </div>
                    </div>
                    <!-- </input-field> -->
                  </div>
                  <div
                    *ngIf="
                      myForm.get('messageBody')?.invalid &&
                      myForm.get('messageBody')?.touched
                    "
                  >
                    <span style="color: red">Message body is required</span>
                  </div>
                </input-field>

                <!-- count data -->
                <div class="countData">
                  <p class="count text-xs">
                    <span>{{ getMessageBodyCount.totalCharacters }}</span> /
                    {{ getMessageBodyCount.singleSMSLimit }}
                  </p>
                  <!-- encoding -->
                  <p class="encoding text-xs">
                    {{ getMessageBodyCount.encoding }} encoding,
                    {{ getMessageBodyCount.segments }} SMS
                  </p>
                </div>
              </div>
            </div>
            }
          </div>

          <div
            class="mt-[40px]"
            style="display: flex; align-items: center; gap: 25px"
          >
            <div class="flex" style="align-items: center; gap: 10px">
              <input
                [formControl]="messageType"
                (change)="onRadioChange($event)"
                type="radio"
                name="messageType"
                value="instant"
                [(ngModel)]="selectedMessageType"
                style="width: 20px; height: 20px; border-color: #000000"
              />
              <span style="font-weight: 600; font-size: 16px"
                >Instant message</span
              >
            </div>
            <div class="pl-8 flex" style="align-items: center; gap: 10px">
              <input
                [formControl]="messageType"
                type="radio"
                name="messageType"
                value="schedule"
                [(ngModel)]="selectedMessageType"
                style="width: 20px; height: 20px; border-color: #000000"
                (change)="onRadioChange($event)"
              />
              <span style="font-weight: 600; font-size: 16px"
                >Schedule message</span
              >
            </div>
          </div>

          @if(selectedMessageType === 'schedule'){
          <div
            style="width: 100%"
            class="card bg-white rounded-xl dark:bg-black mt-[40px]"
          >
            <div
              (click)="scheduleView()"
              style="cursor: pointer"
              class="p-5 info-card"
            >
              <p>Schedule message</p>
              <img
                [src]="schedule_view ? 'dropicon.svg' : 'dropup.svg'"
                alt="Dropdown icon"
              />
            </div>
            <div class="border header-line"></div>

            @if(!schedule_view){
            <p
              class="p-5"
              style="font-size: 14px; color: #6c757d; font-weight: 400"
            >
              Choose the date range and select the specific dates and times to
              send each message.
            </p>
            } @if(schedule_view){
            <p
              class="p-5"
              style="font-size: 14px; color: #6c757d; font-weight: 400"
            >
              Choose the date range and select the specific dates and times to
              send each message.
            </p>

            <div class="px-4 flex flex-col w-full">
              <div class="inputs w-full mt-6 grid gap-8">
                <input-field
                  errorMessage="{{ time_zone_error }}"
                  class="w-full"
                  label="Choose time zone"
                  labelClass=""
                >
                  <select
                    [value]="selected_zone"
                    (change)="handleTimeZone($event)"
                    class="input-style !bg-transparent"
                  >
                    <option
                      *ngFor="let row of timeZones"
                      value="{{ row.timezone }}"
                    >
                      {{ row.timezone }} (UTC{{ row.offset }})
                    </option>
                  </select>
                </input-field>
                <div class="flex mb-[35px] gap-5">
                  <input-field
                    errorMessage="{{ s_date_error }}"
                    class="text w-full"
                    label="Choose date"
                  >
                    <input
                      [value]="schedule_date"
                      (change)="handleScheduleDate($event)"
                      type="date"
                      [min]="today"
                      class="input-style"
                    />
                  </input-field>
                  <input-field
                    errorMessage="{{ s_time_error }}"
                    class="text w-full"
                    label="Choose time"
                  >
                    <input
                      [value]="schedule_time"
                      (change)="handleScheduleTime($event)"
                      type="time"
                      class="input-style"
                    />
                  </input-field>
                </div>
              </div>
            </div>
            }
          </div>
          }
        </div>

        <div class="card bg-white rounded-xl dark:bg-black" style="width: 40%">
          <div class="p-5 info-card">
            <p>Preview</p>
          </div>
          <div class="border header-line"></div>

          <!-- list of added phone numbers -->
          <div class="px-5 py-3" style="font-size: 14px; font-weight: 400">
            <p class="bold">Added phone numbers</p>
            <ul
              class="list-disc text-[#5B5B5B] grid grid-cols-2 gap-2 items-center pl-7"
            >
              <li *ngFor="let row of phoneNumbers; index as i">
                <div
                  class="px-2 py-0.5 rounded legacy__number flex items-center w-fit h-fit relative"
                >
                  {{ row }}
                  <!-- <img src="close.svg" style="margin-top: -10px;" alt="close" /> -->

                  <!-- remove tag -->
                  <mat-icon
                    class="absolute top-1/2 -translate-y-1/2 -right-6"
                    (click)="removePhoneNumber(i)"
                  >
                    close
                  </mat-icon>
                </div>
              </li>
            </ul>
          </div>

          <div class="p-5" style="font-size: 14px; font-weight: 400">
            <p class="bold">Selected individual</p>
            <ul class="list-disc pl-7 text-[#5B5B5B]">
              <li
                *ngFor="let row of selected_contacts"
                class="items-center align-middle"
              >
                <div class="flex">
                  <p class="flex-[0.5]">
                    {{ row.firstName }} {{ row.lastName }} {{ row.contactName }}
                  </p>
                  <!-- <img src="close.svg" style="margin-top: -10px;" alt="close" /> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="px-5 mb-5" style="font-size: 14px; font-weight: 400">
            <p class="bold">Selected tags</p>
            <ul class="list-disc pl-7 text-[#5B5B5B]">
              <li
                *ngFor="let row of selected_tags"
                class="items-center align-middle"
              >
                <div class="flex">
                  <p class="flex-[0.5]">{{ row.name }}</p>
                  <!-- <img src="close.svg" style="margin-top: -10px;" alt="close" /> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="px-5 mb-5" style="font-size: 14px; font-weight: 400">
            <p class="bold">Selected organization</p>
            <ul class="list-disc pl-7 text-[#5B5B5B]">
              <li
                *ngFor="let row of selected_organisation"
                class="items-center align-middle"
              >
                <div class="flex">
                  <p class="flex-[0.5]">{{ row?.name }}</p>
                  <!-- <img src="close.svg" style="margin-top: -10px;" alt="close" /> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="px-5" style="font-size: 14px; font-weight: 400">
            <p class="bold">Selected segment</p>
            <ul class="list-disc pl-7 text-[#5B5B5B]">
              <li
                *ngFor="let row of selected_segments"
                class="items-center align-middle"
              >
                <div class="flex">
                  <p class="flex-[0.5]">{{ row.name }}</p>
                  <!-- <img src="close.svg" style="margin-top: -10px;" alt="close" /> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="px-5 mt-5 mb-5" style="font-size: 14px; font-weight: 400">
            <p class="bold">Selected template</p>
            <ul class="list-disc pl-7 text-[#5B5B5B]">
              <li class="items-center align-middle">
                <div class="flex">
                  <p class="flex-[0.5]">{{ selected_template }}</p>
                  <!-- <img src="close.svg" style="margin-top: -10px;" alt="close" /> -->
                </div>
              </li>
            </ul>
          </div>
          <div class="px-5 mt-5 mb-5" style="font-size: 14px; font-weight: 400">
            <p class="bold">Message body</p>
            <ul class="list-disc text-[#5B5B5B]">
              <li class="flex items-center align-middle">
                <p class="flex-[1]">{{ messageValue }}</p>
              </li>
            </ul>
          </div>
          <div
            *ngIf="selectedMessageType === 'schedule'"
            class="pl-5 flex mb-5"
            style="align-items: center; gap: 10px"
          >
            <input
              style="width: 20px; height: 20px; border-color: #000000"
              checked
              [value]="true"
              type="checkbox"
            />
            <span style="font-weight: 600; font-size: 16px"
              >Schedule message</span
            >
          </div>
          <div
            *ngIf="selectedMessageType === 'instant'"
            class="pl-5 flex mb-5"
            style="align-items: center; gap: 10px"
          >
            <input
              style="width: 20px; height: 20px; border-color: #000000"
              checked
              [value]="true"
              type="checkbox"
            />
            <span style="font-weight: 600; font-size: 16px"
              >Instant message</span
            >
          </div>
          <div
            *ngIf="selectedMessageType === 'schedule'"
            class="px-5 mt-5"
            style="font-size: 14px; font-weight: 400"
          >
            <p style="font-weight: 600px">Selected dates and times:</p>
            <ul class="list-d text-[#5B5B5B]">
              <li>Time zone: {{ selected_zone }}</li>
              <li>Date: {{ schedule_date }} , Time: {{ schedule_time }}</li>
            </ul>
          </div>
          <div
            class="pl-5 flex mb-[40px] mt-[20px]"
            style="align-items: center; gap: 10px"
          >
            <button
              [style]="messageValue ? 'inherit' : 'background:gray'"
              [disabled]="messageValue ? false : true"
              (click)="handleMessagePreview()"
              class="bg-primary w-[188px] px-6 py-2 h-[40px] text-white rounded-3xl"
              type="submit"
            >
              Preview
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <message-submit-button
    [disabled]="
      (messageValue && messageSubject && selected_contacts.length) ||
      selected_tags.length ||
      selected_segments.length ||
      selected_organisation.length
        ? false
        : true
    "
    [loading]="loading"
    (cancel)="setDraft()"
  />
</form>
</div>
